import { message } from "antd";
import { getFormFlowList, getCopyType, copyCheck, copy, getFormList } from '../services/home';

// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = '' }) => {
  return put({
    type: 'save',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
    },
  });
};

const initState = () => {
  return {
    workflowList: [],
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    copyModalKey: Date.now(),
    copyModalVisible: false, // 复制弹窗是否打开
    selectModalKey: Date.now() + 1,
    selectModalVisible: false, // 选择弹窗是否打开
    copyTemplateOrgId: '', // 复制库组织id
    copyProgramId: null, // 复制的programId
    errorOrgIds: [], // 复制校验错误的组织id
  };
};

export default {
  namespace: 'workflowHome',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname, query }) => {
        const { appId } = query;
        if (pathname.match(/^\/work[Ff]low\/home$/) ||
          pathname.match(/\/evaDesign$/)
        ) {
          dispatch({
            type: 'fetchList',
            payload: { appId },
          });
        }
      });
    },
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const data = yield call(getFormList, payload);

        yield put({
          type: 'save',
          payload: {
            workflowList: data,
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchCopyType({ payload }, { call, put }) {
      try {
        yield put({ type: 'showCopyModal' });
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { programId } = payload;
        const { templateOrgId } = yield call(getCopyType);

        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
            copyTemplateOrgId: templateOrgId,
            copyProgramId: programId,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 校验组织id是否合法，不合法则返回不合法的组织集合
    *fetchCopyCheck({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { orgIds, resolve, reject } = payload;

        const data = yield call(copyCheck, { orgIds });

        if (data && data.length > 0) {
          reject(data);
        } else {
          resolve();
        }
        yield setSpinProps({ put });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchCopy({ payload }, { call, put }) {
      try {
        yield put({ type: 'showCopyModal' });
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        yield call(copy, { ...payload });

        message.success('复制成功');

        yield put({
          type: 'hideCopyModal',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
    showCopyModal(state, { payload }) {
      return {
        ...state,
        ...payload,
        copyModalVisible: true,
      };
    },
    hideCopyModal(state, { payload }) {
      return {
        ...state,
        ...payload,
        copyModalKey: Date.now(),
        copyModalVisible: false,
        copyTemplateOrgId: '',
        copyProgramId: null, // 复制的programId
        errorOrgIds: [], // 复制校验错误的组织id
      };
    },
  },
};
